exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader-popup{box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/MapsWrapper/MapsWrapper.scss
// module id = 1865
// module chunks = 0